import { type ActionItem, toastStore } from 'shared/ui'
import { writeTextToClipboard } from 'shared/lib'

export const copyEmail = (email: string): ActionItem => {
  return {
    text: 'Copy email',
    icon: 'copy',
    onAction: async () => {
      await writeTextToClipboard(email)

      toastStore.add({
        type: 'info',
        title: 'Email copied',
      })
    },
  }
}
